const normalizeEmail = (email: null | string | undefined) => {
  return email?.trim().toLowerCase();
};

export default normalizeEmail;
